export default __webpack_public_path__ + "static/media/Medium.2c2a00ec.svg";